import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLinkIcon } from 'lucide-react';
export function RSVPForm() {
  return <section id="rsvp" className="py-24 px-6 bg-paper relative overflow-hidden" data-id="element-75">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-sage/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-76" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-terracotta/5 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-77" />

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-79">
          <h2 className="text-4xl md:text-5xl text-ink mb-4" data-id="element-80">
            Will You Join Us?
          </h2>
          <p className="text-ink-light text-lg" data-id="element-81">
            Reserve your spot for the Kan Family Reunion.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-white p-8 md:p-12 rounded-sm shadow-xl shadow-ink/5 border border-ink/5 text-center" data-id="element-82">
          <p className="text-ink-light text-lg mb-8 leading-relaxed" data-id="element-83">
            RSVP if you haven't already!
          </p>

          <a href="https://docs.google.com/forms/d/e/1FAIpQLSdreBrTGsYXr0GkayYBykuJqL8OJI_efeCLEQ0Z0mvYY1R6Iw/viewform?usp=dialog" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-terracotta text-white px-10 py-4 rounded-sm text-lg transition-all hover:bg-[#A85D45] hover:-translate-y-1 hover:shadow-xl hover:shadow-terracotta/20 duration-300" data-id="element-84">
            RSVP
            <ExternalLinkIcon className="w-5 h-5" data-id="element-85" />
          </a>
        </motion.div>
      </div>
    </section>;
}